export class ActionDialogAlreadyOpenError extends Error {
  constructor() {
    super("An action dialog is already open");
    this.name = "ActionDialogAlreadyOpenError";
  }
}

let actionDialogLock = false;

/**
 * Ensures only one action dialog workflow step is active at a time.
 * react-call stacks concurrent calls by default; this preserves the
 * previous ActionDialogProvider rejection behavior.
 */
export async function withActionDialogLock<T>(
  startCall: () => Promise<T>,
): Promise<T> {
  if (actionDialogLock) {
    throw new ActionDialogAlreadyOpenError();
  }

  actionDialogLock = true;
  try {
    return await startCall();
  } finally {
    actionDialogLock = false;
  }
}

/** @internal Test-only reset. */
export function resetActionDialogLockForTests(): void {
  actionDialogLock = false;
}
